"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AggregatedPool", {
    enumerable: true,
    get: function() {
        return AggregatedPool;
    }
});
const _WorkerPool = require("./WorkerPool.js");
const _events = /*#__PURE__*/ _interop_require_default(require("events"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class AggregatedPool extends _events.default {
    stats() {
        const stats = [
            ...this.groupedPools.values(),
            this.defaultPool
        ].reduce((acc, pool)=>{
            if (pool) {
                const poolStats = pool.stats();
                acc.maxWorkerMemoryUsage = Math.max(acc.maxWorkerMemoryUsage, poolStats.maxWorkerMemoryUsage);
                acc.workerRestarts = acc.workerRestarts + poolStats.workerRestarts;
            }
            return acc;
        }, {
            maxWorkerMemoryUsage: 0,
            workerRestarts: 0
        });
        return stats;
    }
    async exec(data, weight, setup, cleanup, abortSignal, priority) {
        const group = this.options.groupBy(data);
        const pool = this.groupedPools.get(group) ?? this.defaultPool;
        if (!pool) {
            throw new Error(`No pool found to be able to run ${group} tasks, try adjusting the maxWorkers & concurrency values`);
        }
        return pool.exec(data, weight, setup, cleanup, abortSignal, priority);
    }
    async close() {
        const promises = [
            ...this.groupedPools.values(),
            this.defaultPool
        ].map((pool)=>pool?.close());
        return Promise.all(promises);
    }
    constructor(options){
        super(), _define_property(this, "options", void 0), _define_property(this, "groupedPools", void 0), _define_property(this, "defaultPool", void 0), this.options = options, this.groupedPools = new Map();
        const { maxWorkers, maxWorkersByGroup, script, workerOptions } = options;
        let totalGroupedWorkers = 0;
        for (const [group, groupMaxWorkers] of maxWorkersByGroup.entries()){
            const pool = new _WorkerPool.WorkerPool({
                maxWorkers: groupMaxWorkers,
                workerOptions,
                script,
                workerIdleMemoryLimit: options.workerIdleMemoryLimit
            });
            this.groupedPools.set(group, pool);
            totalGroupedWorkers += groupMaxWorkers;
        }
        if (totalGroupedWorkers > maxWorkers) {
            throw new Error(`Total maxWorkers (${totalGroupedWorkers}) configured across all groups exceeds concurrency (${maxWorkers}). Try reducing the maxWorkers, or increasing the --concurrency CLI argument, or separate the tasks to be run`);
        }
        const defaultPoolWorkersCount = maxWorkers - totalGroupedWorkers;
        if (defaultPoolWorkersCount > 0) {
            this.defaultPool = new _WorkerPool.WorkerPool({
                maxWorkers: defaultPoolWorkersCount,
                workerOptions,
                script,
                workerIdleMemoryLimit: options.workerIdleMemoryLimit
            });
        }
        this.options.logger.verbose(`Workers pools created:  ${[
            ...maxWorkersByGroup.entries(),
            [
                "default",
                defaultPoolWorkersCount
            ]
        ].map(([group, count])=>`${group} (${count})`).join(", ")}`);
        // Any time the idle event is emitted by any pool, dispatch an aggregated idle event if everything is idle
        const pools = [
            ...this.groupedPools.values(),
            this.defaultPool
        ];
        pools.forEach((pool)=>{
            pool?.on(_WorkerPool.WorkerPoolEvents.idle, ()=>{
                if (pools.every((p)=>p?.isIdle())) {
                    this.emit(_WorkerPool.WorkerPoolEvents.idle);
                }
            });
        });
    }
}
